import TextAudioTranscriptIcon from '@atlaskit/icon-lab/core/text-audio-transcript';
import React from 'react';

export function SvgTranscript() {
  return <TextAudioTranscriptIcon label="" testId="ads-refreshed-icon" />;
}
